@if (required && hasBorder) {
  <div class="weaveFormField"
    [ngClass]="{'inlineSelect': isInline}"
    >
    <div class="weaveSelect">
      @if (description) {
        <div class="applicationHTML" [innerHTML]="description"></div>
      }
      <mat-form-field appearance="outline" class="fullWidth">
        @if (showLabel && label) {
        <mat-label>{{label}}</mat-label>
        }
        <mat-select
          [id]="id"
          [disabled]="disabledFlag"
          (selectionChange)="onFocusOut()"
          [(ngModel)]='model'
          required
          #name="ngModel"
          [aria-label]="label"
          >
          @for (item of options; track $index) {
            <mat-option
              [value]="item.value"
              class="weaveSelectOption"
              [ngClass]="{'darkWeaveSelectOption': isDark}"
              >
              {{item.label}}
            </mat-option>
          }
        </mat-select>
        @if(name.invalid && name.touched) {
        <mat-error>
          {{label || "This field"}} is required
        </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
}
@if (!required && hasBorder ) {
  <div class="weaveFormField"
    [ngClass]="{'inlineSelect': isInline}"
    >
    <div class="weaveSelect">
      @if (description) {
        <div class="applicationHTML" [innerHTML]="description"></div>
      }
      <mat-form-field appearance="outline" class="fullWidth">
        @if (showLabel && label) {
          <mat-label>{{label}}</mat-label>
        }
        <mat-select
          [id]="id"
          [disabled]="disabledFlag"
          (selectionChange)="onFocusOut()"
          [(ngModel)]='model'
          [attr.name]="id"
          #name="ngModel"
          [aria-label]="label"
          >
          @for (item of options; track $index) {
            <mat-option
              [value]="item.value"
              class="weaveSelectOption"
              [ngClass]="{'darkWeaveSelectOption': isDark}"
              >
              {{item.label}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
}

@if(!hasBorder) {
  <div class="weaveFormField">
    <div class="weaveSelect weaveThinSelect" [ngClass]="{'hasLabel': showLabel}">
      <mat-form-field class="fullWidth" [ngClass]="{'custom-select':isLeft}">
        @if (showLabel && label) {
        <mat-label>{{label}}</mat-label>
        }
        <mat-select
          [id]="id"
          [disabled]="disabledFlag"
          (selectionChange)="onFocusOut()"
          [(ngModel)]='model'
          [attr.name]="id"
          #name="ngModel"
          [aria-label]="label"
        >
          @for (item of options; track item) {
            <mat-option
              [value]="item.value"
              class="weaveSelectOption"
              [ngClass]="{'darkWeaveSelectOption': isDark}"
            >
              {{item.label}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
}
